import React, {ReactNode} from "react"
import useBasket, {UseBasket} from "./useBasket"

export interface WithBasket {
  basket: UseBasket
}

const withBasket = <P extends object>(Comp: React.ComponentClass<P>) => {
  return (props: Omit<P, "basket"> & {children?: ReactNode}) => {
    const basket = useBasket()

    return <Comp {...props} basket={basket} />
  }
}

export default withBasket
